import React, { useMemo, useState } from 'react';
import styled from 'styled-components/macro';
import { ReactTagsWrapper } from './ReactTagsWrapper';

type Props = {
  tagsErrors: string[];
  addStatus: string;
  deleteStatus: string;
  className?: string;
  initialValues: {
    userTags: string[];
  };
  onSubmit: (values: { userTags: string[] }) => void;
};

const Fieldset = styled.fieldset`
  & .error-msg {
    text-align: center;
    color: red;
  }

  & .submit-wrap {
    display: flex;
    align-items: flex-end;

    .btn {
      height: 35px;
    }
  }

  & .tags-input {
    display: inline-block;
    margin-right: 10px;
    overflow: hidden;

    @media (max-width: 767px) {
      width: 80%;
    }

    @media (min-width: 768px) {
      width: 470px;
    }

    @media (max-width: 480px) {
      width: 70%;
    }
  }

  & .instructions {
    font-size: 91%;
    color: #000;
  }

  & .update {
    @media (max-width: 767px) {
      width: 17%;
    }
    @media (max-width: 480px) {
      width: 25%;
    }
  }
`;

export const TagForm = (props: Props) => {
  const { addStatus, deleteStatus, tagsErrors = [], onSubmit, className = '', initialValues } = props;
  const [userTags, setUserTags] = useState<string[]>(initialValues.userTags);

  const isDisabled = addStatus === 'loading' || deleteStatus === 'loading';
  const hasErrors = (addStatus === 'fail' || deleteStatus === 'fail') && tagsErrors.length > 0;

  const errorText = useMemo(() => {
    if (!hasErrors) return '';
    return `Unable to ${tagsErrors.map((error) => error).join(' and ')} tags`;
  }, [hasErrors, tagsErrors]);

  return (
    <Fieldset disabled={isDisabled} className={className}>
      <form
        className="handle-submit"
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit({ userTags });
        }}
      >
        <div className="submit-wrap">
          <ReactTagsWrapper value={userTags} onChange={(value) => setUserTags(value)} className="va-m tags-input" />
          <button
            type="button"
            className="btn btn-primary va-m update"
            onClick={() => {
              onSubmit({ userTags });
            }}
          >
            Update
          </button>
        </div>
        {hasErrors && <div className="error-msg">{errorText}</div>}
      </form>
    </Fieldset>
  );
};
